import Enum from '../../utils/enum';

const VisibilityType = new Enum(['VISIBLE', 'HIDDEN', 'PRERENDER'] as const);

export default VisibilityType;
